export function homaService(http) {
    const serviceName = "Homa";

    return {
        getDocumentsByActivityCode:(activityCode)=>{
            const data={
                    activityCode
                }
                return http.get(`${serviceName}?activityCode=${activityCode}`);
        },
        getDocumentsDropDownListByActivityCode:(activityCode)=>{
            return http.get(`${serviceName}/GetDocumentsDropDownListByActivityCode?activityCode=${activityCode}`);
        },
        getDropDownListByActivityIds:(activityIds)=>{

            const _ids=activityIds.map(a=>`activityIds=${a}`).join('&');
            return http.get(serviceName + `/GetDropDownListByActivityIds?${_ids}`);
        },
    }
}